import axios from 'axios';
import React, { useEffect, useState } from 'react';
import './MyEarnings.css';

const MyEarnings = () => {
  const [data, setData] = useState([]);
  const [user, setUser] = useState([]);
  const [totalPoints, setTotalPoints] = useState(0);


  // Load user from localStorage
  useEffect(() => {
    // try {
    //   const userData = localStorage.getItem('userLogin');
    //   if (userData) {
    //     const parsed = JSON.parse(userData);
    //     setUser(parsed);
    //   }
    // } catch (error) {
    //   console.error('Error reading login info:', error);
    // }
    const googleLogin = localStorage.getItem('googleLogin');

    if (googleLogin == 'false') {
      const data = localStorage.getItem('userLogin');
      if (data) setUser(JSON.parse(data));
    } else {
      const data = localStorage.getItem('userDashboardLogin');
      if (data) setUser(JSON.parse(data));
    }
  }, []);

  // Fetch earnings when user is available
  useEffect(() => {
   if (user.userId) {
    axios
      .get(`https://api.bakpoket.com/api/UserDetail1/GetUserEarningsByUserId?userId=${user.userId}`)
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          setTotalPoints(res.data[0].totalPoints);
        } else {
          setTotalPoints(0);
        }
      })
      .catch((err) => {
        console.error('Error fetching earnings:', err);
      });
  }
  }, [user]);

 return (
  <div>
    <h3>My Earnings</h3>
    {Number(totalPoints) === 0 ? (
      <p className='d-flex justify-content-center'>No earnings found.</p>
    ) : (
      <h5>Total Points : {totalPoints}</h5>
    )}
  </div>
);

};

export default MyEarnings;
